const UNSUPPORTED_BROWSER_MARKS = [
  '360SE',
  '360EE',
  '360Chrome',
  'QIHU',
  '360Browser',
  '360',
  'QQBrowser',
  'MQQBrowser',
  'MetaSr',
  'Sogou',
  'SogouMobileBrowser',
  'UCBrowser',
  'UCWEB',
  'Quark',
  'Maxthon',
  '2345Explorer',
  'TheWorld',
  'BIDUBrowser',
  'baidubrowser',
  'LieBao',
  'lbbrowser',
  'MicroMessenger'
]

export function isSupportedBrowser() {
  const ua = navigator.userAgent

  for (const mark of UNSUPPORTED_BROWSER_MARKS) {
    if (ua.includes(mark)) return false
  }

  if (ua.includes('Firefox')) return true
  if (ua.includes('Edg/')) return true
  if (isSafari()) return true
  if (ua.includes('Chrome') && navigator.vendor === 'Google Inc.' && !ua.includes('Quark'))
    return true

  return false
}

/**
 * 判断是否为 Safari 浏览器（排除 Chrome、Android 等）
 */
export function isSafari(): boolean {
  const ua = navigator.userAgent
  return ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('Android')
}

/**
 * 判断是否为 iOS / iPadOS 设备
 * iPadOS 13+ 默认开启「请求桌面网站」，UA 与 Mac 相同（可能含 Chrome 等标识），
 * 需用「Macintosh UA + 多点触控」区分真 Mac（Mac 无触摸屏）。
 */
export function isIOS(): boolean {
  const ua = navigator.userAgent
  return (
    /iPad|iPhone|iPod/.test(ua) || (ua.includes('Macintosh') && navigator.maxTouchPoints > 1)
  )
}

/**
 * 打开新窗口
 * Safari / iOS 设备对 window.open 有限制（非用户手势直接触发时会被拦截），
 * 因此这类设备直接在当前窗口跳转；其余浏览器正常打开新窗口，
 * 若 window.open 返回 null（弹窗被拦截，如异步回调中调用）则兜底当前窗口跳转。
 *
 * @returns 新窗口对象；当前窗口跳转时返回 null
 */
export function openNewWindow(url: string, target: string = '_blank'): Window | null {
  if (isSafari() || isIOS()) {
    window.location.href = url
    return null
  }
  const win = window.open(url, target)
  if (!win) {
    window.location.href = url
  }
  return win
}
